import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import Subheader from 'components/atoms/GefMui/Subheader';

export const Owner = ({ owner, letterSend, psEndDate, contactSource, subheaderTitle }) => (
	<Paper sx={{ p: 3, borderRadius: 2 }}>
		<Stack spacing={2}>
			<Subheader title={subheaderTitle} />
			<SectionHeader text={getLabelMessage('printContactDetail:owner')} />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<OutputTextField
								size="small"
								id="contactSource"
								label={getLabelMessage('contactDetail:contactSource')}
								fullWidth
								value={contactSource}
								slotProps={{
									inputLabel: {
										shrink: !!contactSource,
									},
								}}
							/>
						</Grid>
						<Grid size={12}>
							<OutputTextField
								size="small"
								id="owner"
								label={getLabelMessage('contactDetail:owner')}
								fullWidth
								value={owner}
								slotProps={{
									inputLabel: {
										shrink: !!owner,
									},
								}}
							/>
						</Grid>
						<Grid size={6}>
							<OutputTextField
								size="small"
								id="letterSend"
								label={getLabelMessage('contactDetail:letterSend')}
								fullWidth
								value={letterSend}
								slotProps={{
									inputLabel: {
										shrink: !!letterSend,
									},
								}}
							/>
						</Grid>
						<Grid size={6}>
							<OutputTextField
								size="small"
								id={'psEndDate'}
								label={getLabelMessage('contactDetail:psEndDate')}
								fullWidth
								value={psEndDate}
								slotProps={{
									inputLabel: {
										shrink: !!psEndDate,
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	</Paper>
);

Owner.propTypes = {
	contactSource: PropTypes.string,
	letterSend: PropTypes.string,
	owner: PropTypes.string,
	psEndDate: PropTypes.string,
	subheaderTitle: PropTypes.node,
};

export default Owner;
